var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from "@tanstack/react-query";
import { constant, nonEmptyArray, nonEmptyString, object, positiveInteger, string, } from "decoders";
import config from "~/config";
const deploymentsApiResponseDecoder = nonEmptyArray(object({
    environment: constant("github-pages"),
    id: positiveInteger,
    sha: nonEmptyString,
}));
const deploymentStatusApiResponseDecoder = nonEmptyArray(object({
    state: string,
}));
const useNewSiteVersionAvailable = () => useQuery({
    queryKey: ["newSiteVersionAvailable"],
    queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
        const deploymentsResponse = yield fetch(`https://api.github.com/repos/anthony-j-castro/tiny-recipe-box/deployments?${new URLSearchParams({
            environment: "github-pages",
            per_page: "1",
        })}`);
        const deploymentsResponseJson = yield deploymentsResponse.json();
        const [latestDeployment] = deploymentsApiResponseDecoder.verify(deploymentsResponseJson);
        if (latestDeployment.sha === config.GITHUB_COMMIT_SHA) {
            return false;
        }
        const deploymentStatusResponse = yield fetch(`https://api.github.com/repos/anthony-j-castro/tiny-recipe-box/deployments/${latestDeployment.id}/statuses?${new URLSearchParams({
            per_page: "1",
        })}`);
        const deploymentStatusResponseJson = yield deploymentStatusResponse.json();
        const [latestDeploymentStatus] = deploymentStatusApiResponseDecoder.verify(deploymentStatusResponseJson);
        return latestDeploymentStatus.state === "success";
    }),
    refetchInterval: 10 * 60 * 1000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
});
export default useNewSiteVersionAvailable;
